/**
 * Shared price formatting — the ONE place currency display rules live.
 * Previously four pages each carried their own copy of this logic and they
 * drifted (ItemPage was missing BDT; the admin Overview hardcoded "$").
 */

// Currencies that are displayed without decimals (large-denomination or
// zero-decimal currencies). Everything else gets 2 decimals.
export const CURRENCY_DECIMALS = {
  JPY: 0, KRW: 0, VND: 0, IDR: 0, HUF: 0, CLP: 0, COP: 0, CRC: 0, MMK: 0, KHR: 0,
  TWD: 0, ISK: 0, UGX: 0, RWF: 0, XOF: 0, XAF: 0, LBP: 0, IQD: 0, YER: 0, MNT: 0,
  UZS: 0, PGK: 0, BYN: 0, MKD: 0, IRR: 0, BDT: 2,
};

export function formatPrice(amount, currencyCode = 'USD') {
  const code = currencyCode || 'USD';
  const decimals = CURRENCY_DECIMALS[code] !== undefined ? CURRENCY_DECIMALS[code] : 2;
  try {
    return new Intl.NumberFormat('en', {
      style: 'currency', currency: code,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(amount);
  } catch {
    return code + ' ' + Number(amount).toFixed(decimals);
  }
}
